import styled from 'styled-components';
import React from 'react';
import {Title} from '../../../elements/txt/Txt';
import {Btn} from '../../../../ui-toolkit/elements/button/btn-type/Btn';
import {Icon} from '../../../elements/Icon/Icon';
import {ColContainer} from './ColContainer';
import {SpinnerLoader} from '../../../animation-v2/loading-spinner/LoadingSpinner';

const Col = ({children, colsize, ...props}) => (
    <ColWrapper {...props} colsize={colsize}>
        {children}
    </ColWrapper>
);

const ColWrapper = ({colsize, title, children, editable, editClick, loading, fixedLoading, emptyState}) => (
    <ColContainer colsize={colsize} $loading={loading} $emptyState={emptyState}>
        {title && (
            <Wrapper>
                <Title main>
                    {title}
                    {editable && (
                        <Btn color="primary" link type="button" onClick={editClick}>
                            <Icon name="edit" />
                        </Btn>
                    )}
                </Title>
            </Wrapper>
        )}
        {children}
        {loading && <SpinnerLoader isLoading />}
        {fixedLoading && <SpinnerLoader isLoading center="page" />}
    </ColContainer>
);

const Wrapper = styled.div`
    > div {
        display: flex;
        button {
            margin-left: 8px;
        }
    }
`;
Col.Wrapper = ColContainer;
export {Col, ColContainer, ColWrapper};
